import { trackCatalogEvent } from '~/modules/catalogEventTracking.js'

export function initAudioToolCtaTracking(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') {
    return
  }

  root.querySelectorAll('[data-audio-tool-cta]').forEach((element) => {
    if (element.dataset.audioToolTrackingInitialized === 'true') {
      return
    }

    element.dataset.audioToolTrackingInitialized = 'true'
    element.addEventListener('click', () => {
      trackCatalogEvent('tool_cta_clicked', {
        tool_key: element.dataset.audioToolKey,
        cta_key: element.dataset.audioToolCta,
        destination: element.getAttribute('href'),
        location: window.location.pathname
      })
    })
  })
}
